import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Radio } from "../radio/index";
export const RadioGroup = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {{ id?: string, value: string, label?: string }[]} props.values
 * @param {string} props.name
 * @param {string | number} props.initialValue
 * @param {(e: MouseEvent) => any} props.onChange
 * @param {"horizontal" | "vertical"} [props.direction]
 * @param {"small" | "regular"} [props.size]
 * @param {any} props.children
 * @param {any} props.className
 * @param {*} ref
 * @returns {JSX.Element}
 */
function RadioGroup({
  values,
  name,
  initialValue,
  onChange,
  direction = "horizontal",
  size = "regular",
  children,
  className
}, ref) {
  const [currentlySelected, setCurrentlySelected] = useState(initialValue ? initialValue : "");

  const handleOnChange = e => {
    setCurrentlySelected(e.target.value);
    typeof onChange === "function" && onChange(e);
  };

  const radioGroupClasses = classNames(["flex", className], {
    "flex-row": direction === "horizontal",
    "flex-col": direction === "vertical"
  });
  return /*#__PURE__*/React.createElement("div", {
    className: radioGroupClasses,
    role: "radiogroup",
    ref: ref
  }, children ? children({
    current: currentlySelected,
    onChange: handleOnChange
  }) : values.map((valueObj, index) => {
    // if not id is supplied, use the value with not spaces
    const id = valueObj.id ? valueObj.id : valueObj.value.replace(" ", "");
    return /*#__PURE__*/React.createElement(Radio, {
      key: `radio-${name}-${index}`,
      name: name,
      value: valueObj.value,
      label: valueObj.label,
      id: id,
      current: currentlySelected,
      onChange: handleOnChange,
      size: size
    });
  }));
});
RadioGroup.propTypes = {
  // @ts-ignore
  values: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string,
    id: PropTypes.string
  })),
  name: PropTypes.string.isRequired,
  initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  // @ts-ignore
  direction: PropTypes.oneOf(["vertical", "horizontal"]),
  // @ts-ignore
  size: PropTypes.oneOf(["small", "regular"]),
  className: PropTypes.string,
  children: PropTypes.node
};